import { render, staticRenderFns } from "./ForeignCurrencyForm.vue?vue&type=template&id=70f78180&scoped=true&"
import script from "./ForeignCurrencyForm.vue?vue&type=script&lang=js&"
export * from "./ForeignCurrencyForm.vue?vue&type=script&lang=js&"
import style0 from "./ForeignCurrencyForm.vue?vue&type=style&index=0&id=70f78180&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f78180",
  null
  
)

export default component.exports